import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {load, save, modify, handleActive, devDelPer} from "api/Device";
import {resultAlert} from "utils/C";

const intialValue = { imei: "", serialNumber:"", name: "",  local: "", address: "", deviceAddress:"", instDt: "", note:"", users:[], status: 0, useYn:'y', addr_lat:0, addr_lng:0};
const intialCheck = { imei: false, serialNumber:false, name: false};

export const deviceSlice = createSlice({
    name: "device",
    initialState: {
        value: intialValue,
        check: intialCheck,
        chg : false,
    },
    reducers: {
        // 장비 정보 json 입력
        deviceInfo: (state, { payload }) => {
            state.value = payload;
        },
        // 장비 관리
        setUsers: (state, { payload }) => {
            state.value.users = payload;
        },
        // 장비 정보 입력 유효성 체크   
        deviceCheck: (state, { payload }) => {
            state.check = payload;
        },
        // 장비 정보 json 초기화
        deviceReset: (state) => {
            state.value = intialValue;
            state.check = intialCheck;
        },
        // 장비 추가
        deviceSave: (state) => {
            state.value.local = state.value.address.split(" ")[0];
            save(state.value).then( res =>  {
                resultAlert(res); 
            } );
        },
        // 장비 수정
        deviceModify: (state) => {
            state.value.local = state.value.address.split(" ")[0];
            modify(state.value).then( res =>  {
                resultAlert(res); 
            } );
        },
        // 장비 삭제
        deviceActive: (state) => {
            handleActive({imei : state.value.imei}).then( res => {
                resultAlert(res);
                location.reload();
            } );
        },
        // 장비 영구삭제
        // delePer: (state) => {
        //     devDelPer(state.value.imei).then( res =>  {
        //         resultAlert(res);
        //     });
        // },
    },
    extraReducers : (builder) => {
         builder
        .addCase(asyncLoad.fulfilled, (state, { payload }) => {
            state.value = payload;
        })
        .addCase(deviceActive.fulfilled, (state, { payload }) => handleResponse(state, payload))
        .addCase(deviceModify.fulfilled, (state, { payload }) => handleResponse(state, payload))
        .addCase(deviceSave.fulfilled, (state, { payload }) => handleResponse(state, payload))
        .addCase(delePer.fulfilled, (state, { payload }) => handleResponse(state, payload));
    }
});

const handleResponse = (state, payload) => {
    if (payload) state.chg = !state.chg;
    resultAlert(payload);
};
// 장비 상세 로드
export const asyncLoad = createAsyncThunk('device', async (imei) => {
    return load(imei); 
});
export const deviceActive = createAsyncThunk('deviceActive', async (imei) => {
    return handleActive(imei); 
});

export const deviceModify = createAsyncThunk('deviceModify', async (device) => {
    const response  = await modify(device); 
    return response;
});

export const deviceSave = createAsyncThunk('deviceSave', async (device) => {
    const response  = await save(device);
    return response;
});

export const delePer = createAsyncThunk('devDel', async (imei) => {
    return devDelPer(imei); 
});

export default deviceSlice.reducer;
export const { deviceInfo, deviceCheck, deviceReset, setUsers } = deviceSlice.actions;